/**
 * PROVISIONAL — the crafting workshop's power input (owner decisions 2026-10-07).
 *
 * Power is one continuous value: a multiple of the wielder's own hit at full
 * Mastery. The presets are named points on that scale, not separate budgets.
 * Every number here is a placeholder the owner has not ratified. Kept free of
 * engine imports so the browser bundle can share it.
 *
 * Contract: docs/gameplay/craft-pricing-v1.md
 */

export const CRAFT_POWER_PRESETS = Object.freeze({ HIGH_REPEAT: 3, MID: 6.5, HEAVY: 20 } as const);
export type CraftPowerPreset = keyof typeof CRAFT_POWER_PRESETS;

/** A request without a power gets this preset (keeps old clients working). */
export const DEFAULT_CRAFT_POWER_MULTIPLE: number = CRAFT_POWER_PRESETS.MID;

/** Slider bounds the workshop offers; the upper bound is the weapon's cap. */
export const CRAFT_POWER_MIN_MULTIPLE = 1;
export const CRAFT_POWER_STEP = 0.5;

/**
 * PROVISIONAL legality while the continuous budget function is undecided:
 * activation damage at the anchor may not exceed this many `H_ref`
 * (`resolveHRef(anchor level)`, the BALANCED reference hit).
 */
export const CRAFT_POWER_CAP_H_REF_MULTIPLE = 40;

/** The largest power multiple the cap allows for a weapon with this hit at the anchor. */
export function maxCraftPowerMultiple(weaponHitDamage: number, hRef: number): number {
  if (!(Number.isFinite(weaponHitDamage) && weaponHitDamage > 0)) throw new Error(`weaponHitDamage must be finite > 0 (got ${weaponHitDamage})`);
  if (!(Number.isFinite(hRef) && hRef > 0)) throw new Error(`hRef must be finite > 0 (got ${hRef})`);
  return CRAFT_POWER_CAP_H_REF_MULTIPLE * hRef / weaponHitDamage;
}
